<template>
	<div class="container">

		<section class="content" id="privacy-policy">
      <h1>Informativa Privacy</h1>
      
      <p>Informativa resa ai sensi dell&rsquo;art. 13 del Regolamento (UE) 2016/679 (di seguito anche "Regolamento") e dell&rsquo;art. 13 D.Lgs. 30 giugno 2003 n. 196 e successive modifiche.</p>
      
      <p>Gentile Utente, desideriamo informarla che il trattamento dei dati personali da Lei forniti mediante il Sito Web o comunque raccolti mediante il Sito Web in relazione all`utilizzo dei servizi offerti ("Servizi") &egrave; e sar&agrave; improntato ai principi di liceit&agrave;, correttezza, trasparenza e di tutela della Sua riservatezza e dei Suoi diritti. Ai sensi del Regolamento La informiamo di quanto segue:</p>
      
      <p>TITOLARE DEL TRATTAMENTO</p>
      <p>Titolare del Trattamento &egrave; la societ&agrave; biG S.r.l.; in persona del proprio legale rappresentante pro tempore , con sede Legale e Amministrativa: via Flavio Gioia, 8 - 20149 Milano, Italia; Capitale Sociale &euro; 8.000.000 i.v.; C.F. - P.IVA e iscr. Reg. Imp. - MI n. 04492200961 - R.E.A. di Milano n. 1751372</p>
      
      <p>RESPONSABILE DEL TRATTAMENTO</p>
      <p>Responsabile del Trattamento &egrave; la societ&agrave; Quomi Srl, con sede legale in via Abbondio Sangiorgio 12 - 20145 Milano, Italia; C.F. - P.IVA: 08635750964 &ndash; R.E.A. di Milano n. 2039267</p>

      <p>RESPONSABILE DELLA PROTEZIONE DEI DATI</p>
      <p>Il Responsabile della Protezione dei Dati pro-tempore &egrave; il Sig. Francesco Carducci, indirizzo e- mail:dpo@it.lactalis.com, domiciliato per la carica presso la Sede Legale della Societ&agrave; in via Flavio Gioia, 8, 20149, Milano.</p>
      
      <p>FINALIT&Agrave; E MODALIT&Agrave; DEL TRATTAMENTO</p>
      <p>I dati da Lei liberamente forniti verranno utilizzati, con modalit&agrave; prevalentemente automatizzate, per le seguenti finalit&agrave;:</p>
      <p>a) per finalit&agrave; essenziali quali:</p>
      <p>1. la creazione e gestione del Suo account, e della sicurezza, in caso di eventuale registrazione;</p>
      <p>2. per la registrazione al Sito e per finalit&agrave; connesse all&rsquo;utilizzo del Sito stesso nonch&eacute; per l&lsquo;utilizzo dei servizi riservati agli utenti registrati fra cui, in via meramente esemplificativa e non esaustiva, l&rsquo;acquisto e/o la prenotazione e/o l&rsquo;ordine di prodotti online.</p>
      <p>b) Previo Suo consenso, per finalit&agrave; di marketing, mediante l'invio di via posta, e-mail, SMS, social network, notifiche push, fax e telefono, newsletter e comunicazioni/offerte commerciali (anche personalizzate, in caso di consenso prestato anche al successivo punto c) da parte di BiG S.r.l. e\o societ&agrave; terze da queste designate e per analisi statistiche, sondaggi e indagini di mercato relative ai loro prodotti.</p>
      <p>c) Previo Suo consenso, per finalit&agrave; di profilazione, ivi incluso a mero titolo esemplificativo il trattamento dei dati relativi alle proprie scelte, abitudini e preferenze di acquisto e di consumo, dell'area geografica di riferimento, nonch&eacute; per la creazione di profili (individuali e/o aggregati) allo scopo di proporre offerte e/o iniziative mirate che potrebbero essere di Suo interesse.</p>
		</section>

	</div>
</template>
<script>
export default {
	data () {
		return {
			

		}
	},

}
</script>

<style>
	#privacy-policy h1, h2, h3 {
		text-align: left;
	}
</style>
<style scoped>
.container {
	overflow-wrap: break-word;
	word-wrap: break-word;
	-ms-word-break: break-all;
	/* This is the dangerous one in WebKit, as it breaks things wherever */
	word-break: break-all;
	/* Instead use this non-standard one: */
	word-break: break-word;
	/* Adds a hyphen where the word breaks, if supported (No Blink) */
	-ms-hyphens: auto;
	-moz-hyphens: auto;
	-webkit-hyphens: auto;
	hyphens: auto;
}

.header {
	font-size: 30px;
	text-align:center;
	margin-bottom: 10px;
}

.content {
	padding: 20px 0;
	color: #575A5C;
	margin: 0 auto;
	width: 90%;
	max-width: 1024px;
}
h2 {
	text-align: center;
}
p {
	font-size: 15px;
	text-align:justify;
	margin-bottom: 10px;
}
ul {
	font-size: 15px;
	text-align:justify;
	margin-left: 40px;
	list-style: initial;
}


</style>
